
import { Tbl_tipocartellinoEdit } from './tbl_tipocartellinoEdit';
import { Tbl_tipocartellinoList } from './tbl_tipocartellinoList';
import { Tbl_tipocartellinoShow } from './tbl_tipocartellinoShow';
import { Tbl_tipocartellinoCreate } from './tbl_tipocartellinoCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_tipocartellinoList,
    edit: Tbl_tipocartellinoEdit,
    show: Tbl_tipocartellinoShow,
    create: Tbl_tipocartellinoCreate,
    icon: MapIcon
};
            